import appAxios from './axios';

class WhatsappService {
  async signin(phone) {
    return appAxios.post(`/auth/whatsapp/sign`, { phone });
  }
  async verify(phone, password, phonePrefix) {
    return appAxios.post(`/app/auth/whatsapp/verify`, { phone, password, phonePrefix });
  }
}

const whatsappService = new WhatsappService();
export default whatsappService;
